module.exports = {
	"se": [
		{
			"id": "lindquists-nhl-blogg",
			"author": "Jonatan Lindquist",
			"name": "Lindquists NHL-blogg",
			"images": {
				"square": "se/hockey_square.jpg",
				"round": "se/hockey_round.png"
			},
			"description": "Jonatan Lindquist är viasatsport.se:s NHL-korrespondent. Med utgång från hemmet i Los Angeles bevakar han världens hockeyliga på plats och bjuder på det hetaste snacket både på och utanför isen."
		},
		{
			"id": "bojan-djordjic",
			"author": "Bojan Djordjic",
			"name": "Bojan Djordjic",
			"images": {
				"square": "se/bojan_square.png",
				"round": "se/bojan_round.png"
			},
			"description": "Bojan Djordjic, 33 år, har spelat internationell fotboll på den största scenen under många år. Mittfältaren startade sin karriär i Brommapojkarna, innan han lämnade Sverige för spel i Manchester United 1999. Han tillhörde den anrika klubben under fem år, och har därefter spelat för klubbar som Sheffield Wednesday, Röda Stjärnan, Glasgow Rangers - och givetvis AIK. 2014 var Djordjic lagkapten för Chennaiyin FC i Indian Super League. Nu jobbar han för AIK:s ungdomsorganisation och bloggar/krönikerar på viasatsport.se. Kontakt: webbsport@viasat.se"
		},
		{
			"id": "blomqvists-formel-1",
			"author": "Janne Blomqvist",
			"name": "Blomqvists formel 1",
			"images": {
				"square": "se/janne_square.png",
				"round": "se/janne_round.png"
			},
			"description": "Janne Blomqvist har refererat Formel 1 på tv sedan 1997. Varje F1-helg kan du höra honom på Viasat Motor. I denna blogg bjuder Janne på analyser, tankar och annat intressant från både försäsong och tävlingssäsong."
		},
		{
			"id": "jihdes-hockeykronika",
			"author": "Niklas Jihde",
			"name": "Jihdes hockeykrönika",
			"images": {
				"square": "se/jihde_square.png",
				"round": "se/jihde_round.png"
			},
			"description": "Niklas Jihde lever för hockey. Här kommer Viasat Hockeys programledare att ge dig sina åsikter från världens bästa hockeyligor - och bjuda på hemligheter från det som händer när kamerorna släckts. Kontakt: niklas.jihde@viasat.se"
		},
		{
			"id": "sillybloggen",
			"author": "Sillybloggen",
			"name": "Sillybloggen",
			"images": {
				"square": "se/silly_square.jpg",
				"round": "se/silly_round.jpg"
			},
			"description": "Häng med i Sillybloggen där viasatsport.se tar greppet om de hetaste snackisarna, övergångarna och ryktena i Europas största fotbollsligor. Tips? Mejla webbsport@viasat.se"
		}
	],
	"dk": [
		{
			"id": "premier-league-bloggen",
			"author": "Jan Mølby",
			"name": "Jan Mølbys klumme",
			"images": {
				"square": "dk/molby_square.jpg",
				"round": "dk/molby_round.jpg"
			},
			"description": "Jan Mølby spillede i en 12-årig periode fra 1984 hos Liverpool, hvor han var med til at vinde to engelske mesterskaber og to FA Cup-titler. Den elegante og pasningsstærke midtbanespiller nåede 292 kampe og 61 mål for i den røde trøje. I dag er Jan Mølby ekspertkommentator hos TV3 SPORT, og han giver her sit syn på de store historier, primært fra Premier League."
		},
		{
			"id": "nfl-bloggen",
			"author": "Henrik Levysohn",
			"name": "Levys NFL-klumme",
			"images": {
				"square": "dk/levy_square.jpg",
				"round": "dk/levy_round.png"
			},
			"description": "Han er kendt for at dele vandene. Henrik Levysohn er mangeårig NFL-kommentator og -ekspert hos TV3 SPORT, og han skriver i klummen her om football, football, football."
		},
		{
			"id": "peter-gronborgs-klumme",
			"author": "Peter Grønborg",
			"name": "Peter Grønborgs klumme",
			"images": {
				"square": "dk/gronborg_square.jpg",
				"round": "dk/gronborg_round.jpg"
			},
			"description": "TV3 SPORTs Champions League-vært Peter Grønborg giver her sit syn på aktuelle emner inden for europæisk topfodbold."
		},
		{
			"id": "daniel-ortveds-klumme",
			"author": "Daniel Ortved",
			"name": "Daniel Ortveds klumme",
			"images": {
				"square": "dk/ortved_square.jpg",
				"round": "dk/ortved_round.jpg"
			},
			"description": "Fodboldkommentator og -nørd med stort N. TV3 SPORTs Daniel Ortved har en enorm kærlighed til - og viden om - dansk og international fodbold, og det er de emner, som han skriver om her."
		},
		{
			"id": "handbold-bloggen",
			"author": "Nikolaj Jensen",
			"name": "Håndbold-bloggen",
			"images": {
				"square": "dk/handbold_square.jpg",
				"round": "dk/handbold_round.png"
			},
			"description": "Nikolaj Jensen har gennem flere år fulgt dansk og international håndbold tæt, og her på bloggen kommer han med masser af nyt om, hvad der rører sig på herre- og damesiden i håndboldverdenen."
		}
	],
	"fi": [
		{
			"id": "viasat-sport-finland-vs-r-kioski",
			"name": "Viasat sport Finland vs. R-kioski",
			"author": "Viasat sport Finland vs. R-kioski",
			"images": {
				"square": "fi/betting_square.jpg",
				"round": "fi/betting_round.png"
			},
			"description": "Tervetuloa mukaan Viasat Sport Finlandin ja R-kioskin vedonlyöntiblogiin! #ViasatVedot"
		},
		{
			"id": "jouni-nieminen",
			"name": "Jouni Nieminen",
			"author": "Jouni Nieminen",
			"images": {
				"square": "fi/jouni-nieminen_square.jpg",
				"round": "fi/jouni-nieminen_round.png"
			},
			"description": "Helsingistä kotoisin oleva Jouni Nieminen on seurannut NHL-jääkiekkoa tarkalla silmällä 1970-luvulta lähtien. Karhu-Kissojen kasvatti pelasi kanadalaista juniorikiekkoa Pacific Junior Hockey Leaguessa Kanadan länsirannikolla ja toimi myöhemmin johtotehtävissä Albertan A-junnuliigan Fort Saskatchewan Tradersissä. Jouni on kuusinkertainen Guinnessin maailmanennätyksen haltija urheilumaratoneissa, joilla kerättiin rahaa syöpäsairaaloille. Jouni on kirjoittanut NHL:stä yli 15 vuoden ajan ja asuu aivan tapahtumien keskipisteessä Edmontonissa, josta hän kirjoittaa Viasatille kaksi kertaa viikossa."
		}
	],
	"no": [
		{
			"id": "la-liga-bloggen",
			"author": "Petter Veland",
			"name": "La Liga-bloggen",
			"images": {
				"square": "no/laliga_square.png",
				"round": "no/laliga_round.png"
			},
			"description": "Petter Veland har fulgt La Liga og spansk fotball tett i over 10 år, og har jobbet som kommentator og studioekspert siden 2010. 28-åringen er spesielt opptatt av statistikk og de gode historiene, og vil på denne bloggen forsøke å ​skape ytterligere engasjement rundt verdens beste liga."
		},
		{
			"id": "motorbloggen",
			"author": "Atle Gulbrandsen",
			"name": "Motorbloggen",
			"images": {
				"square": "no/motor_square.png",
				"round": "no/motor_round.png"
			},
			"description": "Atle Gulbrandsen er \"Mr. Formel 1\" i Norge, og har kommentert fra bilsportens elitedivisjon på forskjellige norske TV-kanaler siden 1997. Atle er også selv aktiv bilsportsutøver, og på denne bloggen kan du lese om alt fra motorsportens verden og det som skjer på Viasat Motor."
		},
		{
			"id": "nhlprat",
			"author": "NHLprat",
			"name": "NHLprat",
			"images": {
				"square": "no/NHLprat_square.png",
				"round": "no/NHLprat_round.png"
			},
			"description": "Torgrim Bakke og Roy Ulvmoen driver bloggen NHLprat.com, en blogg som skriver dybdesaker og kommentarer fra verdens tøffeste hockeyliga, National Hockey League. I tillegg har de en ukentlig podcast som dekker de heteste samtaleemnene fra nordamerikansk hockey. For mer NHL-stoff kan du besøke NHLprat.com og følge duoen på @NHLprat på Twitter."
		},
		{
			"id": "stokkebloggen",
			"author": "Roar Stokke",
			"name": "Stokkebloggen",
			"images": {
				"square": "no/stokke_square.png",
				"round": "no/stokke_round.png"
			},
			"description": "Ingen følger UEFA Champions League like tett som Roar Stokke. Les Viasat-kommentatorens tanker om det som skjer i verdens beste klubbturnering, og det som beveger seg i resten av fotball-Europa."
		},
		{
			"id": "champions-league-bloggen",
			"author": "Nicklas Vinde",
			"name": "Champions League-bloggen",
			"images": {
				"square": "no/championsleague_square.jpg",
				"round": "no/championsleague_round.png"
			},
			"description": "Blog om Europas største og mest prestigefyldte klubturnering. Kommentator Niels Christian Frederiksen, reporter Luna Christofi, redaktør Niels Harild samt fodboldekspert Per Frimann ser nærmere på aktuelle emner fra Champions League-universet."
		},
		{
			"id": "nornfl",
			"author": "Jermund Berg",
			"name": "NorNFL-bloggen",
			"images": {
				"square": "no/nornfl_square.png",
				"round": "no/nornfl_round.png"
			},
			"description": "Jermund Berg har fulgt NFL svært tett de siste sesongene og vært involvert under Viasats NFL-sendinger de siste årene. Under 2014 utgjorde han den ene halvdelen av Viasat NFL Podcast, som hver uke diskuterte det som beveget seg i National Football League. NorNFL finner du også på Twitter under @NorNFL."
		},
		{
			"id": "daniel-hoglund",
			"author": "Daniel Høglund",
			"name": "Daniel Høglund",
			"images": {
				"square": "no/daniel_hoglund_square.jpg",
				"round": "no/daniel_hoglund_round.jpg"
			},
			"description": "Daniel Høglund er en mangeårig sportskommentator og programleder på TV og radio. Han har dekket utallige store mesterskap og mange forskjellige idretter. Nå er hovedjobben å kommentere Champions League i fotball og håndball, samt håndballmesterskap. Daniel er også å se som programleder for blant annet amerikansk fotball."
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/config/blogConfig.json
// module id = 955
// module chunks = 1 2